import { ActionContext } from 'vuex';
import { ICitiesOffered } from '@llws/lift-entity-interfaces';
import { Equal, IQueryCommandOptions, Not, convertQueryCommandToQueryString } from '@llws/dynamic-router-utils';
import { adminRequest } from '@/shared/request-configs/admin-request';
import {
  IModifyPayload,
  mergeQueryCommandOptionsV2,
  subsetObject,
} from '@/shared';
import { IFilterPayloadV2 } from '@/shared/interfaces/filter-payload-v2';

export default {
  namespaced: true, // 'cities-offered/'
  state: {
    list: undefined,
    single: undefined,
    filters: undefined,
    pages: undefined,
    pageSingle: undefined,
    loading: true,
  },
  getters: {
    pages(state: any): any[] {
      return [ ...state.pages?.data || [] ];
    },
    pageSingle(state: any): any {
      return { ...state.pageSingle?.data } || null;
    },
    pageMeta(state: any) {
      return state.pages?.meta || null;
    },
  },
  mutations: {
    setPages(state: any, payload: any) {
      if (Array.isArray(payload.data)) {
        state.pages = payload;
      } else {
        state.pageSingle = payload;
      }
    },
    setSingle(state: any, payload: any) {
      state.pageSingle = { data: payload };
    },
  },
  actions: {
    async getPages(ctx: ActionContext<any, any>, payload: IFilterPayloadV2) {
      const defaultFilters: IQueryCommandOptions = {
        where: [ Not(Equal('status', 'deleted')) ],
        orderBy: [ { field: 'title', direction: 'asc' } ],
        limit: 9999,
      };

      const mergedQuery = mergeQueryCommandOptionsV2([
        defaultFilters,
        payload.filters ?? {},
      ]);

      const result = await adminRequest.get(`/property-api/cities-offered${convertQueryCommandToQueryString(mergedQuery)}`);
      ctx.commit('setPages', result);
    },

    async getPageById(ctx: ActionContext<any, any>, payload: IFilterPayloadV2) {
      const result = await adminRequest.get(`/property-api/cities-offered/${payload.id}${convertQueryCommandToQueryString(payload.filters ?? {})}`);
      ctx.commit('setPages', result);
    },

    async savePage(ctx: ActionContext<any, any>, payload: IModifyPayload<number, Partial<ICitiesOffered>>) {
      const formattedData = payload.data;
      const type = payload.id ? 'put' : 'post';

      const result = await adminRequest[type](
        type === 'post' ? `/property-api/cities-offered` : `/property-api/cities-offered/${formattedData.id}`,
        type === 'post' ? subsetObject(formattedData, ['id']) : formattedData,
      );

      if ((result as any).translations) {
        ctx.commit('setPages', {
          data: { ...(result as any).translations },
          meta: null,
        });
      } else if (result.data) {
        const stateData = Array.isArray(result.data) ? result.data[0] : result.data;
        ctx.commit('setPages', {
          data: {
            ...stateData,
          },
          meta: null,
        });

        if (!payload.id) {
          ctx.commit('setPages', {
            data: [ ...[ ctx.getters.pageSingle ], ...ctx.getters.pages ],
            meta: ctx.getters.pageMeta,
          });
        } else {
          const current = ctx.getters.pages;
          const idx = current.findIndex((p: any) => p.id === ctx.getters.pageSingle.id);
          current[idx] = { ...ctx.getters.pageSingle };
          ctx.commit('setPages', {
            data: current,
            meta: ctx.getters.pageMeta,
          });
        }
      }
    },

    async removePage(ctx: ActionContext<any, any>, payload: any) {
      await adminRequest.delete(`/property-api/cities-offered`, [payload.id]);
    },

  },
};
